export default __webpack_public_path__ + "static/media/480_store03-nl-web.efbbd2c1.png";